import { Field, useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import { BlankTarget } from '../../components/BlankTarget';
import { FiftyFiftyElement } from '../../components/FiftyFiftyElement';
import { PTErrors, PTInputSelect, PTInputSelectBasic, PTInputText, PTInputCheckbox, PTInfo } from '../../components/PTElements';
import { appointmentCountEquality, notificationChoreType, recallFilter, scheduleTypes, when_Automated, when_Magntitude, when_MagntitudeBig, when_MagntitudeForever, when_OneOff } from '../../constants';
import { EVO } from '../../EVO';
import { Question } from './Question';

export const NcdStep3 = () => {
    const { values, setFieldValue } = useFormikContext();

    const resetFilters = (e) => {
        setFieldValue('sexes', []);
        setFieldValue('sexesExclude', false);
        setFieldValue('practitioners', []);
        setFieldValue('practitionerExclude', false);
        setFieldValue('appointmentCategories', []);
        setFieldValue('appointmentCategoryExclude', false);
        setFieldValue('businesses', []);
        setFieldValue('businessExclude', false);
        setFieldValue('billableItems', []);
        setFieldValue('billableItemsExclude', false);
        setFieldValue('products', []);
        setFieldValue('productsExclude', false);
        setFieldValue('appointmentTypes', []);
        setFieldValue('appointmentTypeExclude', false);
        setFieldValue('medicalAlerts', []);
        setFieldValue('medicalAlertsExclude', false);
        setFieldValue('cancellationReasons', []);
        setFieldValue('cancellationReasonsExclude', false);
        setFieldValue('attachIcsFile', false);
        setFieldValue('requiresUpcomingAppointmentsCheck', false);
        setFieldValue('appointmentCount', '');

        if (e.value === when_Automated.AfterCreated.value) {
            setFieldValue('isConfirmation', true);
        }
        else {
            setFieldValue('isConfirmation', false);
        }

        if (e.value === when_Automated.BeforeNext.value) {
            setFieldValue('isReminder', true);
        }
        else {
            setFieldValue('isReminder', false);
        }

        if (e.value === when_Automated.OnCount.value) {
            setFieldValue('whenMagnitudeId', when_MagntitudeForever.Forever.value);
            setFieldValue('appointmentCountEqualityId', appointmentCountEquality.Equal.value);
        }
        else {
            setFieldValue('whenMagnitudeId', when_Magntitude.Days.value);
            setFieldValue('appointmentCountEqualityId', appointmentCountEquality.AtLeast.value);
        }
    };

    const renderWhen = () => {
        return <div className="ncd-when-wrapper">
            <div className="ncd-nextapp-wrapper">
                {values.whenAutomatedId === when_Automated.OnCount.value && <Forever />}
                {(values.whenAutomatedId !== when_Automated.OnCount.value || values.whenMagnitudeId !== when_MagntitudeForever.Forever.value) && <div>
                    {values.whenAutomatedId === when_Automated.OnCount.value && values.whenMagnitudeId !== when_MagntitudeForever.Forever.value && <div className="ncd-sub-heading">&nbsp;</div>}
                    <div className="ncd-nextapp-inner">
                    <Field type="number" name="whenAutomatedMagnitudeValue" component={PTInputText} small="true" inline="true" center="true"
                            min={values.whenMagnitudeId === when_Magntitude.Minutes.value ? 5 : 1} step={values.whenMagnitudeId === when_Magntitude.Minutes.value ? 5 : 1} />
                        <Field name="whenMagnitudeId" component={PTInputSelect} options={EVO.getSelectItemFromObjectOfSelectItems(values.whenAutomatedId === when_Automated.OnCount.value ? when_MagntitudeBig : when_Magntitude)}
                            placeholder="" center="true" small="true" inline="true" />
                    </div>
                </div>
                }
                {(values.whenAutomatedId === when_Automated.AfterLast.value ||
                    values.whenAutomatedId === when_Automated.AfterCancelled.value ||
                    values.whenAutomatedId === when_Automated.AfterDna.value) &&
                    <div>
                        <div className="nc-checkbox-info">
                            <Field name="requiresUpcomingAppointmentsCheck" component={PTInputCheckbox} placeholder="Is this a recall?" />
                            <PTInfo info={`If ticked we will only contact the patient if they have no upcoming appointment booked matching your selection below.`} colour="white" />
                        </div>
                        {values.requiresUpcomingAppointmentsCheck && <div>
                            <div className="ncd-only-send">Only send if the patient has not booked an appointment..</div>
                            <Field name="recallFilter" component={PTInputSelect} options={EVO.getSelectItemFromObjectOfSelectItems(recallFilter)}
                                placeholder="" center="true" />
                        </div>}
                    </div>}

                {values.whenAutomatedId === when_Automated.BeforeNext.value && 
                    <div>
                        <div className="nc-checkbox-info">
                            <Field name="isReminder" component={PTInputCheckbox} placeholder="Is this a reminder?" />
                            <PTInfo info={`When ticked we will check that the patient accepts ${choreType(values)} reminders in the Cliniko profile`} colour="white" />
                        </div>
                        <div className="nc-checkbox-info">
                            <Field name="alwaysSendPreApp" component={PTInputCheckbox} placeholder="Include last minute bookings" />
                            <PTInfo info={`This message will send immediately if a patient books after the scheduled send time selected above.`} colour="white" />
                        </div>
                        <div className="ncd-alwayssendpreapp">
                            <BlankTarget text="More info" href="http://help.peptalkr.com.au/en/articles/5292665-last-minute-bookings" />
                        </div>
                    </div>}
                {values.whenAutomatedId === when_Automated.AfterCreated.value &&
                    <div>
                        <div className="nc-checkbox-info">
                            <Field name="isConfirmation" component={PTInputCheckbox} placeholder="Is this a confirmation?" />
                            <PTInfo info={`When ticked we will check that the patient accepts booking confirmation emails in the Cliniko profile`} colour="white" />
                        </div>
                    </div>}
            </div>
        </div>
    };

    return (
        <div>
            {values.notificationType === notificationChoreType.Sms ? <Question>When should we send this SMS?</Question> : <Question>When should this email be sent?</Question>}
            
            {values.scheduleTypeId === scheduleTypes.OneOff.value && <div>
                <Field name="whenOneOffId" component={FiftyFiftyElement} options={EVO.getSelectItemFromObjectOfSelectItems(when_OneOff)} />
                {values.whenOneOffId === when_OneOff.Scheduled.value && <div>
                    <span>What date/time?</span>
                    <Field type="datetime-local" name="whenOneOffDateTime" component={PTInputText} center="true" />
                </div>}
            </div>}
            {values.scheduleTypeId === scheduleTypes.Recurring.value && <div>
                <Field name="whenAutomatedId" component={FiftyFiftyElement} options={EVO.getSelectItemFromObjectOfSelectItems(when_Automated)} onChange={(e) => resetFilters(e)}>
                    {renderWhen()}
                </Field>
            </div>}
            <PTErrors fields={['whenOneOffId', 'whenOneOffDateTime', 'whenAutomatedId', 'whenMagnitudeId', 'whenAutomatedMagnitudeValue']} />
        </div>
    );
}

const choreType = chore => chore.notificationType === notificationChoreType.Email ? 'email' : 'SMS';

const Forever = () => {
    const foreverValues = {
        Forever: { value: 1, label: 'Over all time' },
        SetPeriod: { value: 2, label: 'Over a set period of time' }
    };
    const { values, setFieldValue } = useFormikContext();
    const [oldMag, setOldMag] = useState(when_Magntitude.Days.value);
    const [selected, setSelected] = useState(foreverValues.Forever);

    const updateForever = e => {
        if (e.value === foreverValues.Forever.value) {
            // set to 7 and store old one...
            setOldMag(values.whenMagnitudeId);
            setFieldValue('whenMagnitudeId', when_MagntitudeForever.Forever.value);
        }
        else {
            setFieldValue('whenMagnitudeId', oldMag);
        }
    };

    useEffect(() => {
        const val = values.whenMagnitudeId === when_MagntitudeForever.Forever.value ? foreverValues.Forever : foreverValues.SetPeriod;
        setSelected(val)
    }, [values.whenMagnitudeId]);

    return <div className="ncd-counttrigger-period">
        <PTInputSelectBasic
            field={{ name: '', value: selected.value }}
            options={EVO.getSelectItemFromObjectOfSelectItems(foreverValues)}
            classNamePrefix="pt-input-select"
            onChange={updateForever}
        />
        </div>
};


// WEBPACK FOOTER //
// ./src/pages/NotificationChore/NcdStep3.js